import onReady from '../../../helpers/onReady'

onReady(function () {
  $('.ui.menu a.item')
    .on('click', function () {
      $(this)
        .addClass('active')
        .siblings()
        .removeClass('active')
    })
})
